export const removeNaN = (word) => {
  return word?.replace(/[^\d.]/g, '')
}
